import { render, staticRenderFns } from "./ring-group-reporting.vue?vue&type=template&id=5c2089fe&scoped=true"
import script from "./ring-group-reporting.vue?vue&type=script&lang=js"
export * from "./ring-group-reporting.vue?vue&type=script&lang=js"
import style0 from "./ring-group-reporting.vue?vue&type=style&index=0&id=5c2089fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2089fe",
  null
  
)

export default component.exports